// extracted by mini-css-extract-plugin
export default {"tablerow":"TableRow_tablerow__1Hg7O","tablerow__toolbox":"TableRow_tablerow__toolbox__3mtkD"};